import { call, put } from 'redux-saga/effects';
import * as transactionsActions from '../actions/transactions';
import { normalizeCrossBorderTransactions } from '../../utils/recipientHelpers';
import * as API from './api';

function* getTransactions() {
  try {
    const transactions = yield call(API.getTransactions);
    yield put({
      type: transactionsActions.GET_TRANSACTIONS_SUCCESS,
      payload: normalizeCrossBorderTransactions(transactions),
    });
  } catch (error) {
    error.name = 'Could not get Transactions';
    yield put({ type: transactionsActions.GET_TRANSACTIONS_ERROR, payload: error });
  }
}

function* getTransactionsSummary() {
  try {
    const transactionsSummary = yield call(API.getTransactionsSummary);
    yield put({
      type: transactionsActions.GET_TRANSACTIONS_SUMMARY_SUCCESS,
      payload: transactionsSummary,
    });
  } catch (error) {
    error.name = 'Could not get Transactions Summary';
    yield put({ type: transactionsActions.GET_TRANSACTIONS_SUMMARY_ERROR, payload: error });
  }
}

const sagas = [
  [transactionsActions.GET_TRANSACTIONS, getTransactions],
  [transactionsActions.GET_TRANSACTIONS_SUMMARY, getTransactionsSummary],
];

export default sagas;
